export default string => string.replace(/[\t\s\n]*/gu, '');



// WEBPACK FOOTER //
// ./src/utils/removeWhiteSpace.js